import { WeightUnit } from "@/Common/Utilities/Units/Units";

class OntarioObstetricalFileMetadata {
    public isReuseVitalSignOptionSet: boolean;
    public subsequentVisitsTableWeightUnit: WeightUnit;

    public constructor(fields?: Partial<OntarioObstetricalFileMetadata>) {
        this.subsequentVisitsTableWeightUnit = sessionStore.useMetricSystemAsDefault ? WeightUnit.Kilogram : WeightUnit.Pound;
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalFileMetadata };
